<template>
  <div>
    <li
      class="mb-2 d-flex flex-row align-items-center justify-content-between"
      style="cursor:pointer;"
      :class="{'bg-light':open}"
      @click="open=!open"
    >
      <b class="text-capitalize">{{ index }}</b>
      <div class="icon col-6">
        <i class="fa fa-chevron-right text-muted" :class="{'active':open}"></i>
      </div>
    </li>
    <div v-show="open">
      <li v-for="circle in section" id="nav-dashboard" :key="circle._id" class="sidemenu-item">
        <img
          v-if="circle.upload && circle.upload.path"
          class="rounded-circle"
          width="24"
          :src="circle.upload.path"
          alt
        />
        <img v-else class="rounded-circle" width="24" src="../../../assets/avatar-circle.png" alt />

        <router-link 
          v-if="menuFor==='feed'" 
          :to="'/circle/' + circle._id"
        >{{ circle.title }}</router-link>
        <a
          v-else
          href
          class="d-flex flex-row no-color-decoration"
          @click.prevent.stop="setCircleTopics(circle)"
        >{{circle.title}}</a>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandableMenuList",
  props: ["index", "section", "setCircleTopics", "menuFor"],
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss" scoped>
.icon > i {
  transition: ease 0.2s transform;
  &.active {
    transform: rotate(90deg);
  }
}

.sidemenu {
  background: #fff;
  border-right: 1px solid #ececec;
  box-sizing: border-box;
  font-size: 13px;
  height: 100%;
  overflow: scroll;
  padding: 68px 30px 0;
  position: fixed;
  top: 0;
  transition: all 0.3s;
  width: 260px;
  z-index: 100;
  @media (max-width: 767px) {
    padding: 60px 20px 0;
    transform: translateX(-100%);
  }
}

.sidemenu .sidemenu-content {
  margin-top: 20px;
}

.sidemenu.sidemenu-visible {
  @media (max-width: 767px) {
    transform: translateX(0%);
  }
}

.sidemenu-menu {
  list-style: none;
  padding: 0;
}

.sidemenu-menu li.sidemenu-item {
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 34px;
  padding: 0 10px;
  transition: all 0.5s;
  a {
    color: var(--grey);
    display: inline-block;
    font-weight: 500;
    line-height: 30px;
    position: relative;
    text-decoration: none;
    width: 100%;
    // Truncate long text
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}

.sidemenu-menu li.sidemenu-item.active {
  background: rgba(47, 113, 255, 0.1);
}

.sidemenu-menu li.sidemenu-item.active a {
  color: var(--primary-color);
}

.sidemenu-menu li.sidemenu-divider {
  color: rgba(23, 28, 52, 0.7);
  font-size: 12px;
  font-weight: 700;
  margin: 30px 0 5px 10px;
  text-transform: uppercase;
}

.sidemenu-menu li.sidemenu-item:not(.active):hover {
  background: rgba(123, 123, 123, 0.05);
}

.sidemenu-item {
  img {
    margin-bottom: 3px;
    margin-right: 6px;
  }
  ion-icon {
    font-size: 16px;
    position: relative;
    top: 3px;
    margin-right: 6px;
  }
}
</style>